import angular from 'angular';
import RwBoxComponent from './rw-box-component';

export default angular.module('rw-box', []).component('rwBox', RwBoxComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-box/rw-box-module.js